export const SEO_DEFAULT_TITLE = 'Telia Company';
export const SEO_DEFAULT_DESCRIPTION = 'Reinvent better connected living';
